// extracted by mini-css-extract-plugin
module.exports = {"modal-form":"ModalForm_modal-form__AIckb"};